import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    "en-GB": {
        translation: {
            "Sea": "Sea",
            "Air": "Air",
            "Land": "Land",
            "Rail": "Rail",
            "Domestic": "Domestic",
            "Irish Domestic": "Irish Domestic",
            "From": "From",
            "To": "To",
            "Select Location": "Select Location",
            "Provide Full Address": "Provide Full Address",
            "Pickup Required": "Pickup Required",
            "Delivered to Recipient": "Delivered to Recipient",
            "From Address": "From Address",
            "To Address": "To Address",
            "Select Station": "Select Station",
            "Get a spot offer": "Get a spot offer",
            "Great. Please select a service": "Great. Please select a service",
            "Select Airport": "Select Airport",
            "What are the cargo details?": "What are the cargo details?",
            "Pieces": "Pieces",
            "Package Type": "Package Type",
            "Commodity": "Commodity",
            "Weight/Piece": "Weight/Piece",
            "Weight": "Weight",
            "Length/Piece": "Length/Piece",
            "Width/Piece": "Width/Piece",
            "Height/Piece": "Height/Piece",
            "Volume (total)": "Volume (total)",
            "Cargo Description": "Cargo Description",
            "HS Code": "HS Code",
            "Total": "Total",
            "Collection Address": "Collection Address",
            "Address Line": "Address Line",
            "Street Number": "Street Number",
            "City": "City",
            "State": "State",
            "Country": "Country",
            "Zip Code": "Zip Code",
            "Cargo Ready Date": "Cargo Ready Date",
            "Shipment Recipient": "Shipment Recipient",
            "Note": "Note",
            "Handling": "Handling",
            "L/C Handling": "L/C Handling",
            "Secured Shipment": "Secured Shipment",
            "Incoterm": "Incoterm",
            "I am an Importer": "I am an Importer",
            "I am an Exporter": "I am an Exporter",
            "Incoterm Location": "Incoterm Location",
            "Reference": "Reference",
            "Reference No.": "Reference No.",
            "Beverages, Foods & Plants": "Beverages, Foods & Plants",
            "Chemicals & Healthcare": "Chemicals & Healthcare",
            "Furniture & Accessories": "Furniture & Accessories",
            "Industrial Products": "Industrial Products",
            "Apparels and Accessories": "Apparels and Accessories",
            "Building Materials": "Building Materials",
            "Vehicles, Engines & Spare Parts": "Vehicles, Engines & Spare Parts",
            "Appliances and Materials": "Appliances and Materials",
            "Leisure Items": "Leisure Items",
            "Paperboard & Prints": "Paperboard & Prints",
            "Non-perishable Foods": "Non-perishable Foods",
            "Water, Soft Drinks": "Water, Soft Drinks",
            "Still and Sparkling Wines": "Still and Sparkling Wines",
            "Spirits, Liquors": "Spirits, Liquors",
            "Fresh & Frozen Products": "Fresh & Frozen Products",
            "Tobacco": "Tobacco",
            "Plants, Flowers & Seeds": "Plants, Flowers & Seeds",
            "Pharmaceutical Goods": "Pharmaceutical Goods",
            "Cosmetics, Well-being Products": "Cosmetics, Well-being Products",
            "Perfumes": "Perfumes",
            "Chemicals, Cleaning Products & Drugstore Products": "Chemicals, Cleaning Products & Drugstore Products",
            "Decor Articles": "Decor Articles",
            "Lights": "Lights",
            "Carpets": "Carpets",
            "Curtains, Sheets": "Curtains, Sheets",
            "Un-disassembled Furniture (Home-office)": "Un-disassembled Furniture (Home-office)",
            "Ceramics, Porcelain & Chinaware": "Ceramics, Porcelain & Chinaware",
            "Personal/Removal Effects": "Personal/Removal Effects",
            "Collection Items or Pictures, Mirror, Glass, Artcrafts, Sculpture, Antiques, etc.": "Collection Items or Pictures, Mirror, Glass, Artcrafts, Sculpture, Antiques, etc.",
            "Finished and Semi-finished Products (incl. Spare Parts) in Metal": "Finished and Semi-finished Products (incl. Spare Parts) in Metal",
            "Finished and Semi-finished Products (incl. Spare Parts) in Rubber or Plastics": "Finished and Semi-finished Products (incl. Spare Parts) in Rubber or Plastics",
            "Finished and Semi-finished Products (incl. Spare Parts) in Wood or Woodenware": "Finished and Semi-finished Products (incl. Spare Parts) in Wood or Woodenware",
            "Raw Materials (Minerals, Paper, Metal, Wood, Gas & Petroleum)": "Raw Materials (Minerals, Paper, Metal, Wood, Gas & Petroleum)",
            "Shoes": "Shoes",
            "Textile/Garments, New Clothes (in Parcels)": "Textile/Garments, New Clothes (in Parcels)",
            "Fashion Accessories": "Fashion Accessories",
            "Fashion Jewellery": "Fashion Jewellery",
            "Used Clothes": "Used Clothes",
            "Textile/Garments, New Clothes on Hangers": "Textile/Garments, New Clothes on Hangers",
            "Leather, Skins": "Leather, Skins",
            "Jewellery and Precious Goods (incl. Watches)": "Jewellery and Precious Goods (incl. Watches)",
            "Building Materials, Doors, Goods out of Stone, Cement": "Building Materials, Doors, Goods out of Stone, Cement",
            "Plastic Tubes, Plumbing Facilities": "Plastic Tubes, Plumbing Facilities",
            "Hardware, Valves, Locks": "Hardware, Valves, Locks",
            "Floor Cover": "Floor Cover",
            "Heat Material and Boilermaking": "Heat Material and Boilermaking",
            "Lights, Lighting Equipment & Luminous Advertising": "Lights, Lighting Equipment & Luminous Advertising",
            "Solar Panels": "Solar Panels",
            "Glass, Glass Products & Windows": "Glass, Glass Products & Windows",
            "Paint, Varnish and Glue": "Paint, Varnish and Glue",
            "Automotive Spare Parts": "Automotive Spare Parts",
            "Aeronautics Spare Parts": "Aeronautics Spare Parts",
            "Engines/motors": "Engines/motors",
            "Tires": "Tires",
            "Vehicles incl. Motorbikes & Bicycles": "Vehicles incl. Motorbikes & Bicycles",
            "Medical Appliance": "Medical Appliance",
            "IT Devices (Computers, Screens)": "IT Devices (Computers, Screens)",
            "CD, DVD & Digital Media": "CD, DVD & Digital Media",
            "Camping and Fishing Equipment": "Camping and Fishing Equipment",
            "Sport Equipment (no Clothes)": "Sport Equipment (no Clothes)",
            "Music Instruments and Accessories": "Music Instruments and Accessories",
            "Laboratory, Optical & Measurement Material": "Laboratory, Optical & Measurement Material",
            "Electric & Electronics Devices, Cables": "Electric & Electronics Devices, Cables",
            "Tools": "Tools",
            "Others Appliances and Materials": "Others Appliances and Materials",
            "Cultural Products (Books, Games, etc.)": "Cultural Products (Books, Games, etc.)",
            "Gifts, Corporate Gifts & Advertising Items": "Gifts, Corporate Gifts & Advertising Items",
            "Toys (new)": "Toys (new)",
            "Toys (used)": "Toys (used)",
            "Creative Leisure, Art & Craft materials": "Creative Leisure, Art & Craft materials",
            "Magazines, Reviews & Newspapers": "Magazines, Reviews & Newspapers",
            "Technical Handbook": "Technical Handbook",
            "Books": "Books",
            "Advertising Documents": "Advertising Documents",
            "Stickers": "Stickers",
            "Documents with Data, Letters, Passports, Tickets, Medical, Medical X-Ray": "Documents with Data, Letters, Passports, Tickets, Medical, Medical X-Ray",
            "Select...": "Select...",
            "Select": "Select",
            "Europallet": "Europallet",
            "Carton": "Carton",
            "One-way pallet": "One-way pallet",
            "Crate": "Crate",
            "Bundle": "Bundle",
            "kg": "kg",
            "cm": "cm",
            "m³": "m³",
            "Business/Company": "Business/Company",
            "Private Home": "Private Home",
            "Shipper's Reference No.": "Shipper's Reference No.",
            "Consignee's Reference No.": "Consignee's Reference No.",
            "Type to search...": "Type to search...",
            "EXW": "EXW",
            "FCA": "FCA",
            "CPT": "CPT",
            "CIP": "CIP",
            "DAP": "DAP",
            "DPU": "DPU",
            "Chargeable Weight": "Chargeable Weight",
            "Volume": "Volume",
            "Submit": "Submit",
            "LCL": "LCL",
            "20′ DC": "20′ DC",
            "40′ DC": "40′ DC",
            "40′ HC": "40′ HC",
            "OT": "OT",
            "RF": "RF",
            "FR": "FR",
            "Other Specialized": "Other Specialized",
            "Thank you for your interest, To provide you a quote tell us how to reach you?": "Thank you for your interest, To provide you a quote tell us how to reach you?",
            "Full Name": "Full Name",
            "Company Name": "Company Name",
            "Email": "Email",
            "Phone Number": "Phone Number",
            "Address": "Address",
            "Street": "Street",
            "VAT ID": "VAT ID",
            "Latest Delivery Date": "Latest Delivery Date",
            "Message": "Message",
            "I agree to be contacted by E2G regarding my quotation request": "I agree to be contacted by E2G regarding my quotation request",
            "I agree to be kept informed via telephone or email about dedicated offers, news, products and services as well as special offers. I can cancel my subscription at any time.": "I agree to be kept informed via telephone or email about dedicated offers, news, products and services as well as special offers. I can cancel my subscription at any time.",
            "I understand that E2G land is a business-to-business platform and does not provide services for private shipper.": "I understand that E2G land is a business-to-business platform and does not provide services for private shipper.",
            "Select Country": "Select Country",
            "Cargo ready date is required": "Cargo ready date is required",
            "Incoterm is required": "Incoterm is required",
            "Incoterm location is required": "Incoterm location is required",
            "Role is required": "Role is required",
            "Pieces are required": "Pieces are required",
            "Package type is required": "Package type is required",
            "Commodity is required": "Commodity is required",
            "Weight per piece is required": "Weight per piece is required",
            "Length per piece is required": "Length per piece is required",
            "Width per piece is required": "Width per piece is required",
            "Height per piece is required": "Height per piece is required",
            "Cargo description is required": "Cargo description is required",
            "Address Line is required": "Address Line is required",
            "Street No. is required": "Street No. is required",
            "City is required": "City is required",
            "State is required": "State is required",
            "Country is required": "Country is required",
            "From location is required": "From location is required",
            "Address is required when pickup is required": "Address is required when pickup is required",
            "From seaport is required when pickup is not required": "From seaport is required when pickup is not required",
            "To location is required": "To location is required",
            "Address is required when delivery to recipient is required": "Address is required when delivery to recipient is required",
            "To seaport is required when delivery to recipient is not required": "To seaport is required when delivery to recipient is not required",
            "Shipment recipient is required": "Shipment recipient is required",
            "Must be a positive number": "Must be a positive number",
            "From City": "From City",
            "To City": "To City",
            "Other": "Other"
        }
    },
    "zh-CN": {
        translation: {
            "Sea": "海运",
            "Air": "空运",
            "Land": "陆运",
            "Rail": "铁路运输",
            "Domestic": "国内",
            "Irish Domestic": "爱尔兰国内",
            "From": "从",
            "To": "至",
            "Select Location": "选择位置",
            "Provide Full Address": "提供完整地址",
            "Pickup Required": "需要取件",
            "Delivered to Recipient": "送货给收件人",
            "From Address": "从地址",
            "To Address": "至地址",
            "Select Station": "选择站点",
            "Get a spot offer": "获得报价",
            "Great. Please select a service": "太好了。请选择服务",
            "Select Airport": "选择机场",
            "What are the cargo details?": "货物详情是什么？",
            "Pieces": "件",
            "Package Type": "包装类型",
            "Commodity": "商品",
            "Weight/Piece": "重量/件",
            "Weight": "重量",
            "Length/Piece": "长度/件",
            "Width/Piece": "宽度/件",
            "Height/Piece": "高度/件",
            "Volume (total)": "总体积",
            "Cargo Description": "货物描述",
            "HS Code": "海关编码",
            "Total": "总计",
            "Collection Address": "收货地址",
            "Address Line": "地址行",
            "Street Number": "街道号码",
            "City": "城市",
            "State": "州",
            "Country": "国家",
            "Zip Code": "邮政编码",
            "Cargo Ready Date": "货物准备日期",
            "Shipment Recipient": "收货人",
            "Note": "备注",
            "Handling": "处理",
            "L/C Handling": "信用证处理",
            "Secured Shipment": "安全运输",
            "Incoterm": "国际贸易术语",
            "I am an Importer": "我是进口商",
            "I am an Exporter": "我是出口商",
            "Incoterm Location": "国际贸易术语地点",
            "Reference": "参考",
            "Reference No.": "参考编号",
            "Fashion Jewellery": "时尚珠宝",
            "Used Clothes": "旧衣服",
            "Textile/Garments, New Clothes on Hangers": "纺织品/服装，新衣服挂在衣架上",
            "Provide City/Town": "提供城市/城镇",
            "Leather, Skins": "皮革、皮料",
            "Jewellery and Precious Goods (incl. Watches)": "珠宝和贵重物品（包括手表）",
            "Building Materials, Doors, Goods out of Stone, Cement": "建筑材料、门、石材和水泥制品",
            "Plastic Tubes, Plumbing Facilities": "塑料管道、管道设施",
            "Hardware, Valves, Locks": "五金、阀门、锁具",
            "Floor Cover": "地板覆盖物",
            "Heat Material and Boilermaking": "隔热材料和锅炉制造",
            "Lights, Lighting Equipment & Luminous Advertising": "灯具、照明设备和发光广告",
            "Solar Panels": "太阳能板",
            "Glass, Glass Products & Windows": "玻璃、玻璃制品和窗户",
            "Paint, Varnish and Glue": "油漆、清漆和胶水",
            "Automotive Spare Parts": "汽车零部件",
            "Aeronautics Spare Parts": "航空零部件",
            "Engines/motors": "发动机/电机",
            "Tires": "轮胎",
            "Vehicles incl. Motorbikes & Bicycles": "车辆（包括摩托车和自行车）",
            "Medical Appliance": "医疗器械",
            "IT Devices (Computers, Screens)": "IT设备（电脑、屏幕）",
            "CD, DVD & Digital Media": "光盘、DVD和数字媒体",
            "Camping and Fishing Equipment": "露营和钓鱼设备",
            "Sport Equipment (no Clothes)": "运动设备（不含服装）",
            "Music Instruments and Accessories": "乐器及配件",
            "Laboratory, Optical & Measurement Material": "实验室、光学和测量材料",
            "Electric & Electronics Devices, Cables": "电气和电子设备、电缆",
            "Tools": "工具",
            "Others Appliances and Materials": "其他设备和材料",
            "Cultural Products (Books, Games, etc.)": "文化产品（书籍、游戏等）",
            "Gifts, Corporate Gifts & Advertising Items": "礼品、公司礼品和广告物品",
            "Toys (new)": "玩具（新）",
            "Toys (used)": "玩具（旧）",
            "Creative Leisure, Art & Craft materials": "创意休闲、艺术和工艺材料",
            "Magazines, Reviews & Newspapers": "杂志、评论和报纸",
            "Technical Handbook": "技术手册",
            "Books": "书籍",
            "Advertising Documents": "广告文件",
            "Stickers": "贴纸",
            "Documents with Data, Letters, Passports, Tickets, Medical, Medical X-Ray": "数据文件、信件、护照、票据、医疗、医学X光",
            "Select...": "选择...",
            "Select": "选择",
            "Europallet": "欧洲托盘",
            "Carton": "纸箱",
            "One-way pallet": "一次性托盘",
            "Crate": "板条箱",
            "Bundle": "捆",
            "kg": "千克",
            "cm": "厘米",
            "m³": "立方米",
            "Business/Company": "商业/公司",
            "Private Home": "私人住宅",
            "Shipper's Reference No.": "发货人参考编号",
            "Consignee's Reference No.": "收货人参考编号",
            "Type to search...": "输入以搜索...",
            "EXW": "工厂交货",
            "FCA": "货交承运人",
            "CPT": "运费付至",
            "CIP": "运费和保险费付至",
            "DAP": "目的地交货",
            "DPU": "目的地卸货交货",
            "Chargeable Weight": "计费重量",
            "Volume": "体积",
            "Submit": "提交",
            "LCL": "拼箱",
            "20′ DC": "20′ DC",
            "40′ DC": "40′ DC",
            "40′ HC": "40′ HC",
            "OT": "OT",
            "RF": "RF",
            "FR": "FR",
            "Other Specialized": "其他专业",
            "Thank you for your interest, To provide you a quote tell us how to reach you?": "感谢您的关注，为了为您提供报价，请告诉我们如何联系您？",
            "Full Name": "全名",
            "Company Name": "公司名称",
            "Email": "电子邮件",
            "Phone Number": "电话号码",
            "Address": "地址",
            "Street": "街道",
            "VAT ID": "增值税号",
            "Latest Delivery Date": "最晚交货日期",
            "Message": "信息",
            "I agree to be contacted by E2G regarding my quotation request": "我同意E2G就我的报价请求与我联系",
            "I agree to be kept informed via telephone or email about dedicated offers, news, products and services as well as special offers. I can cancel my subscription at any time.": "我同意通过电话或电子邮件随时了解有关专门优惠、新闻、产品和服务以及特别优惠的信息。我可以随时取消订阅。",
            "I understand that E2G land is a business-to-business platform and does not provide services for private shipper.": "我了解E2G land是一个面向企业的平台，不为私人托运人提供服务。",
            "Select Country": "选择国家",
            "From location is required": "需要起运地",
            "Cargo ready date is required": "需要货物准备日期",
            "Incoterm is required": "需要国际贸易术语",
            "Incoterm location is required": "需要国际贸易术语地点",
            "Role is required": "需要角色",
            "Pieces are required": "需要件数",
            "Package type is required": "需要包装类型",
            "Commodity is required": "需要商品",
            "Weight per piece is required": "需要每件重量",
            "Length per piece is required": "需要每件长度",
            "Width per piece is required": "需要每件宽度",
            "Height per piece is required": "需要每件高度",
            "Cargo description is required": "需要货物描述",
            "Address Line is required": "需要地址行",
            "Street No. is required": "需要街道号码",
            "City is required": "需要城市",
            "State is required": "需要州",
            "Country is required": "需要国家",
            "Address is required when pickup is required": "需要取件时需要地址",
            "From seaport is required when pickup is not required": "不需要取件时需要起运港",
            "To location is required": "需要目的地",
            "Address is required when delivery to recipient is required": "需要送货给收件人时需要地址",
            "To seaport is required when delivery to recipient is not required": "不需要送货给收件人时需要目的港",
            "Shipment recipient is required": "需要收货人",
            "Must be a positive number": "必须是正数",
            "Beverages, Foods & Plants": "饮料、食品和植物",
            "Chemicals & Healthcare": "化学品和医疗保健",
            "Furniture & Accessories": "家具和配件",
            "Industrial Products": "工业产品",
            "Apparels and Accessories": "服装和配饰",
            "Building Materials": "建筑材料",
            "Vehicles, Engines & Spare Parts": "车辆、发动机和备件",
            "Appliances and Materials": "电器和材料",
            "Leisure Items": "休闲用品",
            "Paperboard & Prints": "纸板和印刷品",
            "Non-perishable Foods": "不易腐烂的食品",
            "Water, Soft Drinks": "水、软饮料",
            "Still and Sparkling Wines": "红酒和起泡酒",
            "Spirits, Liquors": "烈酒、酒类",
            "Fresh & Frozen Products": "新鲜和冷冻产品",
            "Tobacco": "烟草",
            "Plants, Flowers & Seeds": "植物、花卉和种子",
            "Pharmaceutical Goods": "药品",
            "Cosmetics, Well-being Products": "化妆品、保健品",
            "Perfumes": "香水",
            "Chemicals, Cleaning Products & Drugstore Products": "化学品、清洁产品和药店产品",
            "Decor Articles": "装饰品",
            "Lights": "灯具",
            "Carpets": "地毯",
            "Curtains, Sheets": "窗帘、床单",
            "Un-disassembled Furniture (Home-office)": "未拆卸的家具（家庭办公室）",
            "Ceramics, Porcelain & Chinaware": "陶瓷、瓷器和瓷器",
            "Personal/Removal Effects": "个人/搬家效果",
            "Collection Items or Pictures, Mirror, Glass, Artcrafts, Sculpture, Antiques, etc.": "收藏品或图片、镜子、玻璃、工艺品、雕塑、古董等",
            "Finished and Semi-finished Products (incl. Spare Parts) in Metal": "金属制成品和半成品（包括备件）",
            "Finished and Semi-finished Products (incl. Spare Parts) in Rubber or Plastics": "橡胶或塑料制成品和半成品（包括备件）",
            "Finished and Semi-finished Products (incl. Spare Parts) in Wood or Woodenware": "木材或木制品制成品和半成品（包括备件）",
            "Raw Materials (Minerals, Paper, Metal, Wood, Gas & Petroleum)": "原材料（矿物、纸张、金属、木材、煤气和石油）",
            "Shoes": "鞋子",
            "Textile/Garments, New Clothes (in Parcels)": "纺织品/服装、新衣服（包裹装）",
            "Fashion Accessories": "时尚配饰",
            "Select Seaport": "选择海港",
            "From City": "从城市",
            "To City": "到城市",
            "Other": "其他"
        }
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next) // bind react-i18next to the instance
    .init({
        resources,
        fallbackLng: 'en_GB',
        debug: false,

        interpolation: {
            escapeValue: false, // not needed for react!!
        },
    });


export default i18n;
